export default "assets/kgc-logo.png"